import { createFileRoute } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";

/**
 * `/catalogue` — the product list and the price list, one surface, two tabs.
 *
 * THE ADDRESS IS `/catalogue` AND NOTHING AFTER IT. The two section ids were
 * Inventory's until the POC moved them, and an old `?tab=products` or
 * `?tab=pricing` still has to leave the shelf for here (`/inventory`'s route)
 * — then the query is dropped. Both pages are placeholders. `app/tabs.ts`.
 *
 * `VIEW_INVENTORY` and not a right of its own: it is what opens the shelf AND
 * the list of what may go on it. See `app/nav.ts`.
 */
export const Route = createFileRoute("/_authenticated/catalogue")({
  // Its own vocabulary, so an old `?tab=formulary` still resolves — retired
  // once when the product list stopped being only medicines, and again when
  // it left the shelf. The address that remains is `/catalogue`. `app/tabs.ts`.
  validateSearch: tabSearch("catalogue"),
  beforeLoad: (args) => {
    replaceWithBareModule("/catalogue", args.location);
    requirePerm("VIEW_INVENTORY")(args);
  },
  component: () => <PendingSurface titleKey="nav.catalogue" />,
});
